import _typeof from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
import { Message } from 'element-ui';
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time, 10);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time *= 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if ("".concat(time).length === 10) {
    time = parseInt(time, 10) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return "".concat(Math.ceil(diff / 60), "\u5206\u949F\u524D");
  } else if (diff < 3600 * 24) {
    return "".concat(Math.ceil(diff / 3600), "\u5C0F\u65F6\u524D");
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return "".concat(d.getMonth() + 1, "\u6708").concat(d.getDate(), "\u65E5").concat(d.getHours(), "\u65F6").concat(d.getMinutes(), "\u5206");
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  var obj = {};
  var searchArr = search.split('&');
  searchArr.forEach(function (v) {
    var index = v.indexOf('=');
    if (index !== -1) {
      var name = v.substring(0, index);
      var val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 * @param {string} date, fmt格式 例如=> 'yyyy-MM-dd'
 * @returns {string}
 */
export function formartDate(tmpDate, fmt) {
  if (!tmpDate) return '';
  var date;
  if (typeof tmpDate === 'string') {
    date = new Date(tmpDate);
  } else {
    date = tmpDate;
  }
  var o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒
  };

  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr("".concat(o[k]).length));
    }
  }
  return fmt;
}

/**
 * tooltip过长32长度换行
 * @param {string} val
 * @returns {string}
 */
export function valsubstr32addbr(val) {
  var htmlstring = '';
  for (var i = 0; i < 8; i++) {
    if (val.length / 32 > i) {
      htmlstring += "".concat(val.substr(32 * i, 32), "<br />");
    }
  }
  return window.$xss(htmlstring);
}

/**
 * @description 生成文件
 * @param {Blob} data
 * @param {String} 文件名
 * @return {void}
 * @author 🦉Owllai🦉 2022/06/16
 */
export function saveFile(data, name) {
  try {
    var blobUrl = window.URL.createObjectURL(data);
    var a = document.createElement('a');
    a.style.display = 'none';
    a.download = name;
    a.href = blobUrl;
    a.click();
    Message.success('下载成功');
  } catch (e) {
    // alert('保存文件出错');
  }
}

/**
 * @description: 时间格式化
 * @param {*} d
 * @return {*}
 */
export function formatDate(d) {
  var date = new Date(d);
  var y = date.getFullYear();
  var m = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0".concat(date.getMonth() + 1);
  var day = date.getDate() > 9 ? date.getDate() : "0".concat(date.getDate());
  return "".concat(y, "-").concat(m, "-").concat(day);
}

/**
 * Debounces a function, ensuring it is only called after a specified wait time has passed since the last invocation.
 * @param {Function} func - The function to be debounced.
 * @param {number} wait - The number of milliseconds to wait before invoking the debounced function.
 * @returns {Function} - The debounced function.
 */
export function debounce(func, wait) {
  var timeout;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise(function (resolve, reject) {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args).then(resolve).catch(reject);
      }, wait);
    });
  };
}